export interface IGpsItem {
    lat: number,
    lng: number,
    speed: number,
    bp: number,
    tsDt: string
}